import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteBlogTag } from "../../api/apiBlogTags";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف وسام مدونة (soft delete)
 */
export function useDeleteBlogTag() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteBlogTagMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteBlogTag,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-tags"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete blog tag");
        },
    });

    return {
        deleteBlogTagMutate,
        isPending,
    };
}
